import axios from 'axios'
import HTTP from './http'

export default {
    getList: payload => axios.get(HTTP.INSURANCE_CALCULATOR, { params: payload }),
    createReport: payload => axios.post(HTTP.INSURANCE_CALCULATOR, payload),
    comparePolicies: payload => axios.post(HTTP.COMPARE_POLICIES, payload),
    shabanComparisons: () => axios.get(HTTP.SHABAN_COMPARISONS)
}
